<!-- 协议签署 -->
<style lang="scss" scoped>
.sign-agreement-wrapper {
  background: #ffffff;
  padding: 20px;
}
</style>

<template>
  <div class="sign-agreement-wrapper mt-24px">
    <StatusTemplate
      :status="joinData.status"
      :fail-reason="joinData.failReason"
      :corp-type="joinData.corpType"
      :corp-id="joinData.corpId"
      :resubmit="resubmit"
      :close="close"
      :next-step="nextStep"
    ></StatusTemplate>
  </div>
</template>

<script setup>
import StatusTemplate from './status-template.vue'

defineProps({
  joinData: {
    type: Object,
    default: () => {},
  },
  resubmit: {
    type: Function,
    default: () => {},
  },
  nextStep: {
    type: Function,
    default: () => {},
  },
  close: {
    type: Function,
    default: () => {},
  },
})
</script>
